import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Profile.css';

const Profile = () => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <div className="loading">Loading profile...</div>;
  }

  return (
    <div className="profile-container">
      <h2>Profile</h2>
      <div className="profile-content">
        <div className="profile-card">
          <div className="profile-header">
            <div className="profile-avatar">
              {currentUser.name ? currentUser.name[0].toUpperCase() : '👤'}
            </div>
            <div className="profile-info">
              <h3>{currentUser.name || 'User'}</h3>
              <p>{currentUser.email}</p>
            </div>
          </div>
          <div className="profile-details">
            <div className="detail-group">
              <label>Full Name</label>
              <input 
                type="text" 
                value={currentUser.name || ''} 
                readOnly 
                placeholder="Not provided"
              />
            </div>
            <div className="detail-group">
              <label>Email</label>
              <input 
                type="email" 
                value={currentUser.email || ''} 
                readOnly 
                placeholder="Not provided"
              />
            </div>
            <div className="detail-group">
              <label>Member Since</label>
              <input 
                type="text" 
                value={currentUser.createdAt ? new Date(currentUser.createdAt).toLocaleDateString() : 'Unknown'} 
                readOnly 
              />
            </div>
            
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Profile; 